import { Component, OnInit, Renderer2, effect } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import {
  CreateOtpCommand,
  GetOtpsWithPaginationDto,
  OtpStatus,
  UpdateOtpCommand,
} from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { OtpsService } from '../../../../core/api/services/otps.service';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';


@Component({
    selector: 'app-otp-form',
    templateUrl: './otp-form.component.html',
    imports: [BaseFormModule]
})
export class OtpFormComponent extends BaseFormPageComponent implements OnInit {
  //#region Properties

  formPageConfig: FormPageConfig<GetOtpsWithPaginationDto> = {};

  model: any = {};
  get OtpStatusType() {
    return OtpStatus;
  }
  jsonSampleParameter;
  jsonSampleOtp;
  jsonFinalMessage;
  sampleParameter = {
    code: this.translate.instant('pages.otp.form.code'),
    name: this.translate.instant('pages.otp.form.name'),
  };
  sampleOtp = {
    code: this.translate.instant('pages.otp.form.code2'),
    name: this.translate.instant('pages.otp.form.name2'),
    description: this.translate.instant('pages.otp.form.description'),
  };
  finalMessage = {
    code: this.translate.instant('pages.otp.form.code3'),
    name: this.translate.instant('pages.otp.form.name3'),
    description: this.translate.instant('pages.otp.form.description'),
  };

  //#endregion

  constructor(
    protected currentService: OtpsService,
    protected translate: TranslateService,
    private renderer: Renderer2
  ) {
    super();
    effect(() => {
      this.getJsonSampleParameter();
    });
  }

  ngOnInit() {
    try {
      super.ngOnInit();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.setting);
    }
  }

  getJsonSampleParameter() {
    try {
      const sampleParameter = document.getElementById('sampleParameter');
      sampleParameter.innerHTML = '';
      this.jsonSampleParameter = this.sampleParameter;

      const sampleOtp = document.getElementById('sampleOtp');
      this.renderer.setProperty(sampleOtp, 'innerHTML', '');

      this.jsonSampleOtp = this.sampleOtp;

      const finalMessage = document.getElementById('finalMessage');
      this.renderer.setProperty(finalMessage, 'innerHTML', '');

      this.jsonFinalMessage = this.finalMessage;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.setting);
    }
  }
  //#endregion

  //#region init methods

  initForm() {
    this.form = new FormGroup({
      title: new FormControl('', Validators.required),
      smsText: new FormControl('', Validators.required),
    });
  }

  //#endregion

  //#region Api

  //Create
  baseCreateApi(model: CreateOtpCommand) {
    this.unSubs();
    this.loading = true;

    this.currentService
      .otpsCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateOtpCommand) {
    this.unSubs();
    this.loading = true;
    this.currentService
      .otpsUpdatePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion
}
